/**
* 经销商
*/
const dealer = {
  
addDealer: "/api/addDealer",//新增经销商
modifyDealer: "/api/modifyDealer",//修改经销商
getDealer: "/api/getDealer",//查询经销商
getDealer2: "/api/getDealer2",//查询经销商
deleteDealer: "/api/deleteDealer",//删除经销商
addSalesperson: "/api/addSalesperson",//新增销售人员
modifySalesperson: "/api/modifySalesperson",//修改销售人员
getSalesperson: "/api/getSalesperson",//查询销售人员
getSalesperson2: "/api/getSalesperson2",//查询销售人员
deleteSalesperson: "/api/deleteSalesperson",//删除销售人员
}

export default dealer